// Optional per-language overrides for league display names, keyed by the league
// slug (the value used in routes and as the key in the server's /league_name
// lookup). An entry here takes precedence over the server-provided name, so it's
// the place to localize how a league is labelled in the UI for Spanish.
//
// Empty by default — leagues fall back to the server name, then the raw slug.
// Add entries like:
//
//   export default {
//     "epl": "Liga Premier",
//     "laliga": "La Liga",
//   };
export default {
    "fifa.world": "Copa Mundial de la FIFA",
};
